export function shouldHideChatBot(pathname = "") {
  const path = pathname || "";
  return (
    path.endsWith("/test") ||
    path.endsWith("/sectionalTest") ||
    path.includes("/fulltest/")
  );
}
